<div class="relative inline-block text-left w-full">
  <button type="button"
          class="flex items-center space-x-2 w-full text-sm font-semibold rounded-md bg-transparent transition-opacity"
          [ngClass]="{'text-gray-900 cursor-pointer hover:opacity-70': canChangeCompany, 'text-gray-400 cursor-not-allowed': !canChangeCompany}"
          (click)="handleIsOpen()"
          [matTooltip]="tooltipMessage"
          matTooltipPosition="right"
          matTooltipClass="violet-500-tooltip">
    <span class="text-xl text-secondary-900 dark:text-white text-left font-semibold">
      {{ company?.name | slice:0:20 }}{{ company?.name?.length > 20 ? '...' : '' }}
    </span>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
         stroke="currentColor" class="w-4 h-4"
         [ngClass]="{'text-gray-500 dark:text-white': canChangeCompany, 'text-gray-400': !canChangeCompany}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
    </svg>
  </button>

  <div *ngIf="isOpen && canChangeCompany" [@dropdownAnimation]="'visible'" class="tiny-scroll absolute left-0 mt-1 w-80 max-h-80 overflow-y-auto origin-top-right rounded-xl bg-white/95 backdrop-blur-sm shadow-lg z-10 p-2">
    <ul>
      <li
        *ngFor="let item of companies"
        class="flex flex-col px-4 py-2 text-sm rounded-lg"
        [ngClass]="{
            'text-gray-700 cursor-not-allowed opacity-75': isActiveCompany(item),
            'text-gray-700 hover:bg-gray-50 hover:text-gray-700 cursor-pointer opacity-100': !isActiveCompany(item)
          }"
        (click)="!isActiveCompany(item) && selectCompany(item)"
      >
        <span class="font-medium text-gray-700" [ngClass]="{ 'text-gray-400 opacity-80': isActiveCompany(item) }">
          {{ item.name }}
        </span>
        <span *ngIf="item.title" class="text-xs text-gray-500 mt-0.5" [ngClass]="{ 'opacity-80': isActiveCompany(item) }">
          {{ item.title }}
        </span>
        <span *ngIf="item.start_date" class="text-xs text-gray-400 mt-0.5" [ngClass]="{ 'opacity-80': isActiveCompany(item) }">
          {{ item.start_date | date:'MMMM d, y' }} - Present
        </span>
      </li>
    </ul>
  </div>
</div>
